import React from "react";
import { Routes, Route } from "react-router-dom";
import FontLayout from "../Font/components/FontLayout";
import Home from "../Font/pages/Home";
import Aboutus from "../Font/pages/About";
import Contact from "../Font/pages/Contact";
import Partner from "../Font/pages/Partner";

const FontRoutes = () => {
  return (
    <Routes>
      <Route element={<FontLayout />}>

        {/* Home */}
        <Route index element={<Home />} />

        {/* ✅ FIXED ROUTES */}
        <Route path="about" element={<Aboutus />} />
        <Route path="contact" element={<Contact />} />
        <Route path="partner" element={<Partner />} />

      </Route>
    </Routes>
  );
};

export default FontRoutes;